import React from 'react'
import { rem } from 'polished'
import { connect } from 'react-redux'
import styled from 'styled-components'

import BodyText from 'components/Luxkit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import Image from 'components/Common/Image'
import TextLink from 'components/Luxkit/TextLink'
import { getSupportContact } from 'selectors/supportContactSelector'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { useTranslation } from 'react-i18next'

interface Props {
  currentContact: App.GeoContacts;
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(32)};
  padding-top: ${rem(40)};
  border-top: 1px solid ${props => props.theme.palette.neutral.five};
  align-items: center;
  margin-top: ${rem(42)};

  ${mediaQueryUp.sm} {
    gap: ${rem(40)};
    padding-top: ${rem(24)};
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }
`

const USP = styled.div`
  display: grid;
  gap: ${rem(20)};
  grid-template-columns: ${rem(160)} 1fr;
  align-items: center;

  ${mediaQueryUp.xs} {
    grid-template-columns: ${rem(100)} 1fr;
  }
`
const ContactUSP = (props: Props) => {
  const contact = props.currentContact[props.currentContact.default]

  const { t } = useTranslation(['common', 'offerPage'])

  return <Container>
    <USP>
      <Image fit="center" id="d5sfjdbpg47k0yfcxxzj" />
      <VerticalSpacer gap={12}>
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-two">
            {t('ourTeamAreAvailable', { ns: 'offerPage' })}
          </BodyText>
          <BodyText variant="medium" colour="neutral-three">
            {t('callOurCSTeamAnytime', { ns: 'offerPage' })}
          </BodyText>
        </VerticalSpacer>
        <TextLink
          size="medium"
          weight="bold"
          href={`tel:${contact.number}`}
          startIcon={<LinePhoneIcon />}
        >
          {t('callNumber', { ns: 'common', phoneNumber: contact.humanReadable })}
        </TextLink>
      </VerticalSpacer>
    </USP>
  </Container>
}

const mapStateToProps = (state: App.State) => {
  return {
    currentContact: getSupportContact(state),
  }
}

export default connect(mapStateToProps)(ContactUSP)
